import { environmentStore } from "../stores/environment";
import { get } from "svelte/store";

declare global {
  interface Window {
    FoojiDevConfig?: {
      FOOJI_DOMAIN?: string;
      FOOJI_MICROSITE_DOMAIN?: string;
    };
  }
}

export const getFoojiDomain = () => get(environmentStore).getFoojiDomain();
export const getBugsnagApiKey = () => get(environmentStore).getBugsnagApiKey();
export const getBusgnagStage = () => get(environmentStore).getBusgnagStage();
export const getFoojiMicrositeDomain = () => get(environmentStore).getFoojiMicrositeDomain();
